function closeProductAccordion(details, summary) {
  const wrapper = details.querySelector('.accordion__content-wrapper');
  if (!wrapper || details.classList.contains('accordion--closing')) return;

  details.classList.add('accordion--closing');
  summary.setAttribute('aria-expanded', 'false');

  const endHeight = wrapper.scrollHeight;
  wrapper.style.height = `${endHeight}px`;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      wrapper.style.height = '0px';
    });
  });

  let finished = false;

  const cleanup = () => {
    if (finished) return;
    finished = true;

    details.removeAttribute('open');
    details.classList.remove('accordion--closing');
    wrapper.style.height = '';
    wrapper.removeEventListener('transitionend', onTransitionEnd);
  };

  const onTransitionEnd = (event) => {
    if (event.target !== wrapper || event.propertyName !== 'height') return;
    cleanup();
  };

  wrapper.addEventListener('transitionend', onTransitionEnd);
  window.setTimeout(cleanup, 900);
}

function closeOtherProductAccordions(currentDetails, animate = true) {
  const container = currentDetails.closest('.product__info-container') || document;

  container.querySelectorAll('.product__accordion-tab details[open]').forEach((details) => {
    if (details === currentDetails) return;

    const summary = details.querySelector('summary');
    if (!summary) return;

    if (animate) {
      closeProductAccordion(details, summary);
    } else {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }
  });
}

function initProductAccordions(container = document) {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  container.querySelectorAll('.product__accordion-tab details').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary || summary.dataset.accordionAnimated === 'true') return;

    summary.dataset.accordionAnimated = 'true';

    summary.addEventListener('click', (event) => {
      if (details.hasAttribute('open')) {
        if (!prefersReducedMotion) {
          event.preventDefault();
          closeProductAccordion(details, summary);
        }
      } else {
        closeOtherProductAccordions(details, !prefersReducedMotion);
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductAccordions());
} else {
  initProductAccordions();
}

document.addEventListener('shopify:section:load', (event) => {
  initProductAccordions(event.target);
});
